import React, { Component } from "react";
import { bool, func } from "prop-types";

import Button from "../../../common/button/Button";
import Row from "../../../common/grid/Row";
import Col from "../../../common/grid/Col";

import MdEdit from "react-icons/lib/md/edit";

class EditDropdown extends Component {
	state = {
		expanded: false
	};

	static propTypes = {
		confirm: func,
		confirmed: bool
	};

	handleClick = () => {
		const { confirm, confirmed } = this.props;
		this.setState({ expanded: !this.state.expanded });
		if (!confirmed) {
			confirm(true, false);
		}
	};

	render() {
		const { children, confirmed } = this.props;
		const { expanded } = this.state;

		let childrenToArray = React.Children.toArray(children);
		return (
			<Row _no-grow-last _gap-24 edit-dropdown>
				<Col>
					{childrenToArray[0]}
					{expanded && confirmed && childrenToArray[1]}
				</Col>
				<div>
					<Button className="btn-blue" onClick={this.handleClick}>
						<MdEdit />
					</Button>
				</div>
			</Row>
		);
	}
}

export default EditDropdown;



// WEBPACK FOOTER //
// ./src/components/main/profile/EditDropdown.js